var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{style:({ 'min-height': '800px' }),attrs:{"fluid":""}},[_c('v-container',{staticClass:"contain-width"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"8","offset-md":"2","lg":"6","offset-lg":"3"}},[_c('h1',{staticClass:"mt-6 mb-6"},[_vm._v("Help Centre")])])],1)],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }